export default __webpack_public_path__ + "static/media/Ashoka_Particle_Flame_3.f7a0aed3.png";